(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════
     THE MODELS — brand-level facts, written once
     ─────────────────────────────────────────────────────────
     Warranty and features belong to the BRAND, not to the
     system size, so they live here and are shared by all four
     systems. The key (MIDEA, MITSU …) is the same code used in
     the SKU keys used in SYSTEMS below.
  ══════════════════════════════════════════════════════════ */
  var MODELS = {
    MIDEA:     { name:'Midea',
                 warranty:'Up to 8 years compressor',
                 feats:['R32 · AI Smart Inverter','Hi-Nano air purification','Golden Fin · 5-Tick rated'] },
    MITSU:     { name:'Mitsubishi Electric Starmex',
                 warranty:'5 years compressor',
                 feats:['R32 · 5-Tick inverter','Anti-allergy enzyme filter','Super quiet Japanese build'] },
    GREE:      { name:'GREE',
                 warranty:'6 years compressor',
                 feats:['G-10 inverter · save up to 60%','As quiet as 19dB(A)','Self Clean X-Fan · I Feel sensor'] },
    HISENSE:   { name:'Hisense',
                 warranty:'6 years compressor · 1+2 years workmanship',
                 feats:['R32 · AI Smart Inverter','Hi-Nano purification','Wi-Fi smart control'] },
    /* sub: printed under the logo. Rocket Series is an MHI product
       line, so it shares the MHI mark — without this caption the two
       tiles are visually identical and look like a duplicate. */
    MHIROCKET: { name:'MHI Rocket Series', sub:'Rocket Series',
                 warranty:'2 years extended warranty included',
                 feats:['WiFi built-in · 5-Tick','Self-clean operation','Heavy duty powerful cooling'] },
    FUJITSU:   { name:'Fujitsu',
                 warranty:'Manufacturer warranty',
                 feats:['Japanese cooling technology','R32 · energy-efficient','Residential & commercial'] },
    DAIKIN:    { name:'Daikin',
                 warranty:'5 years compressor · +2 years extended',
                 feats:['5-Ticks · Coanda airflow','Titanium apatite filter','Free 1-time servicing worth $120'] },
    MHI:       { name:'Mitsubishi Heavy Industries',
                 warranty:'5 years compressor · 1 year parts & labour',
                 feats:['12K BTU units throughout','Energy-saving inverter','Quiet Japanese engineering'] }
  };

  /* ══════════════════════════════════════════════════════════
     THE FOUR SYSTEMS — one Shopify product each
     ─────────────────────────────────────────────────────────
     THE ONLY SOURCE OF TRUTH FOR PRICES AND VARIANTS.
     Prices from the CT Air-Con promotional messages in the
     WhatsApp export, 18 Aug 2026. Variant IDs are live Shopify
     variants created 29 Aug 2026.

     The picker cards and the full price table both render from
     this array. Edit a price here and it changes in both.

     m     model key, into MODELS above
     kind  'Replacement' or 'Full Set'
     btu   printed on the card — MHI differs from the rest
     v     Shopify variant ID (the number after the last slash)
  ══════════════════════════════════════════════════════════ */
  var SYSTEMS = [
    { key:'s2', label:'System 2', handle:'ct-aircon-system-2', models:[
      { m:'MIDEA',     kind:'Replacement', btu:'9K + 9K',   price:2199, v:48279360995554 },
      { m:'MITSU',     kind:'Replacement', btu:'9K + 9K',   price:2299, v:48279361028322 },
      { m:'GREE',      kind:'Replacement', btu:'9K + 9K',   price:2299, v:48279361061090 },
      { m:'HISENSE',   kind:'Replacement', btu:'9K + 9K',   price:2399, v:48279361093858 },
      { m:'MHIROCKET', kind:'Replacement', btu:'9K + 9K',   price:2399, v:48279361126626 },
      { m:'FUJITSU',   kind:'Replacement', btu:'9K + 9K',   price:2499, v:48279361159394 },
      { m:'DAIKIN',    kind:'Replacement', btu:'9K + 9K',   price:2499, v:48279361192162 },
      { m:'MIDEA',     kind:'Full Set',    btu:'9K + 9K',   price:2499, v:48279361224930 },
      { m:'MHI',       kind:'Replacement', btu:'12K + 12K', price:2599, v:48279361257698 },
      { m:'MITSU',     kind:'Full Set',    btu:'9K + 9K',   price:2699, v:48279361290466 }
    ]},
    { key:'s3', label:'System 3', handle:'ct-aircon-system-3', models:[
      { m:'MIDEA',     kind:'Replacement', btu:'9K × 3',    price:2699, v:48279361356002 },
      { m:'HISENSE',   kind:'Replacement', btu:'9K × 3',    price:2899, v:48279361388770 },
      { m:'GREE',      kind:'Replacement', btu:'9K × 3',    price:2999, v:48279361421538 },
      { m:'FUJITSU',   kind:'Replacement', btu:'9K × 3',    price:2999, v:48279361454306 },
      { m:'MHI',       kind:'Replacement', btu:'12K × 3',   price:3099, v:48279361487074 },
      { m:'MITSU',     kind:'Replacement', btu:'9K × 3',    price:3299, v:48279361519842 },
      { m:'MHIROCKET', kind:'Replacement', btu:'9K × 3',    price:3299, v:48279361552610 },
      { m:'MIDEA',     kind:'Full Set',    btu:'9K × 3',    price:3299, v:48279361585378 },
      { m:'DAIKIN',    kind:'Replacement', btu:'9K × 3',    price:3499, v:48279361618146 },
      { m:'MITSU',     kind:'Full Set',    btu:'9K × 3',    price:3799, v:48279361650914 }
    ]},
    { key:'s418', label:'System 4 · 18K', handle:'ct-aircon-system-4-18k', models:[
      { m:'MIDEA',     kind:'Replacement', btu:'9K × 3 + 18K',  price:3299, v:48279365124322 },
      { m:'HISENSE',   kind:'Replacement', btu:'9K × 3 + 18K',  price:3599, v:48279365157090 },
      { m:'GREE',      kind:'Replacement', btu:'9K × 3 + 18K',  price:3899, v:48279365189858 },
      { m:'FUJITSU',   kind:'Replacement', btu:'9K × 3 + 18K',  price:3899, v:48279365222626 },
      { m:'MITSU',     kind:'Replacement', btu:'9K × 3 + 18K',  price:3999, v:48279365255394 },
      { m:'MHI',       kind:'Replacement', btu:'12K × 3 + 18K', price:3999, v:48279365288162 },
      { m:'MHIROCKET', kind:'Replacement', btu:'9K × 3 + 18K',  price:4199, v:48279365320930 },
      { m:'MIDEA',     kind:'Full Set',    btu:'9K × 3 + 18K',  price:4199, v:48279365353698 },
      { m:'DAIKIN',    kind:'Replacement', btu:'9K × 3 + 18K',  price:4399, v:48279365386466 },
      { m:'MITSU',     kind:'Full Set',    btu:'9K × 3 + 18K',  price:4799, v:48279365419234 }
    ]},
    { key:'s424', label:'System 4 · 24K', handle:'ct-aircon-system-4-24k', models:[
      { m:'MIDEA',     kind:'Replacement', btu:'9K × 3 + 24K',  price:3399, v:48279365550306 },
      { m:'HISENSE',   kind:'Replacement', btu:'9K × 3 + 24K',  price:3699, v:48279365583074 },
      { m:'GREE',      kind:'Replacement', btu:'9K × 3 + 24K',  price:3999, v:48279365615842 },
      { m:'FUJITSU',   kind:'Replacement', btu:'9K × 3 + 24K',  price:3999, v:48279365648610 },
      { m:'MITSU',     kind:'Replacement', btu:'9K × 3 + 24K',  price:4199, v:48279365681378 },
      { m:'MHI',       kind:'Replacement', btu:'12K × 3 + 24K', price:4199, v:48279365714146 },
      { m:'MHIROCKET', kind:'Replacement', btu:'9K × 3 + 24K',  price:4299, v:48279365746914 },
      { m:'MIDEA',     kind:'Full Set',    btu:'9K × 3 + 24K',  price:4299, v:48279365779682 },
      { m:'DAIKIN',    kind:'Replacement', btu:'9K × 3 + 24K',  price:4499, v:48279365812450 },
      { m:'MITSU',     kind:'Full Set',    btu:'9K × 3 + 24K',  price:4899, v:48279365845218 }
    ]}
  ];

  var DEPOSIT = 100;

  function money(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  }); }


  /* ── trust marquee ── */
  var MQ = [
    'Free site survey & quotation', '$400 Climate Voucher accepted', 'HDB Registered Contractor',
    'BCA Licensed B2', 'bizSAFE STAR', 'Google 5.0 reviews', 'Established 2011',
    'GST included', 'Old aircon disposal included', 'Direct contractor — no middleman'
  ];

  /* ══ FULL PRICE TABLE — one row per model+kind ═══════════ */
  function renderTable() {
    var tbody = document.getElementById('ctTableBody');
    if (!tbody) return;

    /* collect every distinct model+kind across all four systems,
       then look up its price in each — so a package that only
       exists at some sizes still shows a dash, not a wrong number */
    var order = [], seen = {};
    SYSTEMS.forEach(function (s) {
      s.models.forEach(function (r) {
        var id = r.m + '|' + r.kind;
        if (!seen[id]) { seen[id] = { m: r.m, kind: r.kind, cells: {} }; order.push(id); }
        seen[id].cells[s.key] = r;
      });
    });

    /* cheapest System 2 price first, to match the picker's default */
    order.sort(function (a, b) {
      var pa = seen[a].cells.s2 ? seen[a].cells.s2.price : 1e9;
      var pb = seen[b].cells.s2 ? seen[b].cells.s2.price : 1e9;
      return pa - pb;
    });

    var built = order.map(function (id) {
      var row = seen[id];
      return '<tr>' +
        '<th scope="row" class="ct-table-brand">' + esc(MODELS[row.m].name) +
          '<span class="ct-table-sub">' + esc(row.kind) + ' package</span></th>' +
        SYSTEMS.map(function (s) {
          var c = row.cells[s.key];
          if (!c) return '<td>&mdash;</td>';
          return '<td class="ct-price">' + money(c.price) +
                 '<span class="ct-table-sub">' + esc(c.btu) + '</span></td>';
        }).join('') +
      '</tr>';
    }).join('');

    /* The same rows are written into the HTML source so crawlers and no-JS
       visitors see all forty prices. If someone edits CTA_PACKAGES and
       forgets that static copy, the two diverge: visitors still see correct
       prices because this overwrites them, but search engines keep reading
       the stale version. Say so rather than failing silently. */
    var norm = function (h) { return h.replace(/\s+/g, ''); };
    if (norm(tbody.innerHTML) !== norm(built) && window.console && console.warn) {
      console.warn('[CT Air-Con] The static price table in the HTML no longer matches ' +
        'CTA_PACKAGES. Visitors see the right prices, crawlers see the stale copy. ' +
        'Regenerate the rows inside <tbody id="ctTableBody">.');
    }
    tbody.innerHTML = built;
  }

  /* ══ REVEALS ═════════════════════════════════════════════ */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ct-vis'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
  }
  function revealScan() {
    Array.prototype.slice.call(document.querySelectorAll('.ct-reveal:not(.ct-vis)')).forEach(function (el) {
      if (io) { io.observe(el); } else { el.classList.add('ct-vis'); }
    });
  }

  /* ══ INIT ════════════════════════════════════════════════ */
  function init() {
    var mqEl = document.getElementById('ctMq');
    if (mqEl) {
      mqEl.innerHTML = MQ.concat(MQ).map(function (t) {
        return '<div class="ct-mq-item"><div class="ct-mq-dot"></div><span>' + esc(t) + '</span></div>';
      }).join('');
    }

    /* Step 2 logos are Liquid/theme-editor blocks — not filtered by Step 1. */
    renderTable();

    /* Step 1 product carousel arrows */
    Array.prototype.slice.call(document.querySelectorAll('.ct-prod-car')).forEach(function (car) {
      var track = car.querySelector('.ct-prod-track');
      var prev  = car.querySelector('.ct-prod-car-prev');
      var next  = car.querySelector('.ct-prod-car-next');
      if (!track || !prev || !next) return;

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    Array.prototype.slice.call(document.querySelectorAll('.ct-faq-q')).forEach(function (q) {
      q.addEventListener('click', function () {
        /* closest(), not parentNode — the button now sits inside an <h3>
           so the question is real document structure, which puts one more
           element between it and .ct-faq-item */
        var item = q.closest ? q.closest('.ct-faq-item') : q.parentNode.parentNode;
        if (!item) return;
        var panel = item.querySelector('.ct-faq-a');
        if (!panel) return;
        var open = item.classList.contains('ct-open');
        item.classList.toggle('ct-open', !open);
        panel.style.maxHeight = open ? '0px' : (panel.scrollHeight + 'px');
      });
    });

    revealScan();

    var sticky = document.getElementById('ctSticky');
    var picker = document.getElementById('ct-picker');
    if (sticky && picker && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('ct-sticky-on', e.boundingClientRect.bottom < 0);
        });
      }, { threshold: 0 }).observe(picker);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();